/**
 * @module M/plugin/ThreeMapea
 */
import 'assets/css/threemapea';
import ThreeMapeaControl from './threemapeacontrol';
import api from '../../api.json';
import { getValue } from './i18n/language';

export default class ThreeMapea extends M.Plugin {
  /**
   * @classdesc
   * Main facade plugin object. This class creates a plugin
   * object which has an implementation Object
   *
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api stable
   */
  constructor(capas) {
    super();
    /**
     * Facade of the map
     * @private
     * @type {M.Map}
     */
    this.map_ = null;

    /**
     * Array of controls
     * @private
     * @type {Array<M.Control>}
     */
    this.controls_ = [];

    /**
     * Metadata from api.json
     * @private
     * @type {Object}
     */
    this.metadata_ = api.metadata;

    /**
     * Array of layers
     * @public
     * @type {Array<String>}
     */
    this.capas = capas;
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api stable
   */
  addTo(map) {
    this.controls_.push(new ThreeMapeaControl(this.capas));
    this.map_ = map;
    this.panel_ = new M.ui.Panel('panelThreeMapea', {
      collapsible: true,
      className:'m-plugin-threemapea',
      position: M.ui.position.TR,
      tooltip: getValue('generate_3d_view'),
      collapsedButtonClass: 'threemapea-plugin-3D',
    });
    this.panel_.addControls(this.controls_);
    map.addPanels(this.panel_);
  }

  /**
   * This function gets metadata plugin
   *
   * @public
   * @function
   * @api stable
   */
  getMetadata(){
    return this.metadata_;
  }
}
